export default "__VITE_ASSET__BvxuYXNr__"